<template>
  <v-container fluid tag="section" class="cyber-news-container">
    <v-row>
      <v-col cols="12" md="4">
        <base-material-card color="#018C74" icon="mdi-newspaper-plus" class="glass-card">
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-text">KABAR BONDOWOSO</div>
            <div class="subtitle-2 secondary-text">Publikasi Informasi</div>
          </template>

          <v-form ref="form" v-model="valid" class="mt-4">
            <v-text-field
              v-model="editedItem.judul_berita"
              label="Headline Berita"
              outlined
              dense
              color="#018C74"
              prepend-inner-icon="mdi-format-title"
              :rules="[(v) => !!v || 'Headline wajib diisi']"
            />

            <v-textarea
              v-model="editedItem.isi_berita"
              label="Konten / Narasi Berita"
              outlined
              dense
              rows="5"
              color="#018C74"
              prepend-inner-icon="mdi-text-subject"
            />

            <v-text-field
              v-model="editedItem.penulis"
              label="Otoritas Penulis"
              outlined
              dense
              color="#018C74"
              prepend-inner-icon="mdi-account-tie-outline"
            />

            <v-file-input
              v-model="files"
              label="Unggah Visual Pendukung"
              multiple
              outlined
              dense
              prepend-inner-icon="mdi-camera-burst"
              prepend-icon=""
              accept="image/*"
              counter
              show-size
              color="#CFA22D"
              class="cyber-file-input"
            />

            <v-btn
              color="#CFA22D"
              block
              large
              :loading="loading"
              @click="save"
              class="cyber-save-btn mt-2"
            >
              <v-icon left>mdi-broadcast</v-icon>
              {{ editedItem.id ? "UPDATE BERITA" : "TERBITKAN BERITA" }}
            </v-btn>

            <v-btn
              block
              large
              color="#004d40"
              :loading="syncLoading"
              @click="syncFromBondowosokab"
              class="mt-3"
            >
              <v-icon left>mdi-cloud-download-outline</v-icon> SINKRON BONDOWOSOKAB
            </v-btn>

            <v-btn
              v-if="editedItem.id"
              block
              text
              color="#6b7b78"
              small
              class="mt-2"
              @click="clearForm"
            >
              BATALKAN EDIT
            </v-btn>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="8">
        <v-card class="glass-card mb-5 pa-2 border-primary" elevation="0">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify-scan"
            label="Cari arsip berita..."
            single-line
            hide-details
            rounded
            color="#CFA22D"
            class="cyber-search"
          ></v-text-field>
        </v-card>

        <v-row>
          <v-col v-for="kabar in filteredKabar" :key="kabar.id" cols="12" sm="6">
            <v-card
              class="cyber-card rounded-lg overflow-hidden glass-card h-100 d-flex flex-column"
            >
              <v-carousel
                v-if="splitFoto(kabar.list_foto).length > 0"
                height="220"
                hide-delimiter-background
                show-arrows-on-hover
                delimiter-icon="mdi-circle-medium"
                class="cyber-carousel"
              >
                <v-carousel-item
                  v-for="(img, i) in splitFoto(kabar.list_foto)"
                  :key="i"
                  :src="`https://berkah.bondowosokab.go.id:5500/uploads/${img}`"
                >
                  <div class="img-overlay"></div>
                </v-carousel-item>
              </v-carousel>
              <v-img
                v-else
                height="220"
                src="https://via.placeholder.com/500x250?text=SIGNAL+LOST"
                class="grayscale"
              />

              <v-card-text class="pa-4 flex-grow-1">
                <div
                  class="white--text font-weight-bold text-h6 mb-2 line-clamp-2 cyber-title"
                >
                  {{ kabar.judul_berita }}
                </div>

                <div class="caption secondary-text d-flex align-center mb-3">
                  <v-icon x-small color="#CFA22D" class="mr-1">mdi-clock-outline</v-icon>
                  {{ formatDate(kabar.tanggal_publish) }}
                  <v-spacer />
                  <v-icon x-small color="#018C74" class="mr-1"
                    >mdi-shield-check-outline</v-icon
                  >
                  {{ kabar.penulis || "KONTRIBUTOR" }}
                </div>

                <p class="cyber-desc text-body-2">
                  {{ kabar.isi_berita }}
                </p>
              </v-card-text>

              <v-divider class="mx-4 opacity-1"></v-divider>

              <v-card-actions class="pa-3">
                <v-chip x-small color="#018C74" class="glow-chip">
                  {{ splitFoto(kabar.list_foto).length }} MEDIA
                </v-chip>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  color="#018C74"
                  @click="editItem(kabar)"
                  class="glow-hover mr-1"
                >
                  <v-icon small>mdi-pencil-box-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="#FF5252"
                  @click="deleteItem(kabar)"
                  class="glow-hover-red"
                >
                  <v-icon small>mdi-delete-variant</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-alert
          v-if="filteredKabar.length === 0"
          type="info"
          text
          class="glass-card mt-4"
          color="#CFA22D"
        >
          SISTEM: Berita dengan parameter tersebut tidak ditemukan dalam database.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    loading: false,
    syncLoading: false,
    valid: true,
    search: "",
    files: [],
    kabarList: [],
    editedItem: {
      id: null,
      judul_berita: "",
      isi_berita: "",
      penulis: "",
    },
  }),

  computed: {
    filteredKabar() {
      return this.kabarList.filter((item) => {
        return item.judul_berita.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },

  mounted() {
    this.fetchKabar();
  },

  methods: {
    async fetchKabar() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/kabar`);
        if (res.data && res.data.response && res.data.response.data) {
          this.kabarList = res.data.response.data;
        } else {
          this.kabarList = res.data.data || [];
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    splitFoto(str) {
      return str ? str.split(",") : [];
    },

    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("id-ID", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },

    async save() {
      if (!this.valid) return;
      this.loading = true;
      const formData = new FormData();
      formData.append("judul_berita", this.editedItem.judul_berita);
      formData.append("isi_berita", this.editedItem.isi_berita);
      formData.append("penulis", this.editedItem.penulis);

      this.files.forEach((file) => {
        formData.append("foto", file);
      });

      try {
        if (this.editedItem.id) {
          await axios.put(`${BASE_URL}/kabar/${this.editedItem.id}`, formData);
        } else {
          await axios.post(`${BASE_URL}/kabar`, formData);
        }
        this.fetchKabar();
        this.clearForm();
        alert("Transmisi Berhasil: Berita Telah Terarsip!");
      } catch (e) {
        alert("Kegagalan Sistem: Gagal mengirim data ke server.");
      } finally {
        this.loading = false;
      }
    },

    editItem(item) {
      this.editedItem = Object.assign({}, item);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    async deleteItem(item) {
      if (confirm(`Hapus Protokol Berita: ${item.judul_berita}?`)) {
        try {
          await axios.delete(`${BASE_URL}/kabar/${item.id}`);
          this.fetchKabar();
        } catch (e) {
          alert("Sistem gagal menghapus data.");
        }
      }
    },

    clearForm() {
      this.editedItem = { id: null, judul_berita: "", isi_berita: "", penulis: "" };
      this.files = [];
      if (this.$refs.form) this.$refs.form.resetValidation();
    },


    async downloadImageAsFile(url) {
      try {
        const response = await axios.get(url, { responseType: "blob" });
        const contentType = response.headers["content-type"];
        const extension = contentType.split("/")[1] || "jpg";
        const fileName = `sync_${Date.now()}.${extension}`;
        return new File([response.data], fileName, { type: contentType });
      } catch (error) {
        console.error(`Gagal mendownload gambar: ${url}`, error);
        return null;
      }
    },

    async syncFromBondowosokab() {
      if (!confirm("Sinkron berita? Backend akan mendownload gambarnya.")) return;

      this.syncLoading = true;
      try {
        const response = await axios.get("https://bondowosokab.go.id/api/news");
        const newsData = response.data.response?.data || [];

        for (const news of newsData) {
          const exists = this.kabarList.some((item) => item.judul_berita === news.title);
          if (exists) continue;

          const formData = new FormData();
          formData.append("judul_berita", news.title);
          formData.append("isi_berita", news.content);
          formData.append("penulis", "BONDOWOSOKAB.GO.ID");

          if (news.image) {
            formData.append("remote_image_url", news.image);
          }

          await axios.post(`${BASE_URL}/kabar`, formData);
        }

        await this.fetchKabar();
        alert("Sinkronisasi selesai.");
      } catch (error) {
        console.error(error);
      } finally {
        this.syncLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.cyber-news-container {
  background: transparent;
}

.glass-card {
  background: rgba(0, 20, 18, 0.9) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.border-primary {
  border: 1px solid #018c74 !important;
}

.cyber-text {
  letter-spacing: 2px;
  color: white !important;
  text-shadow: 0 0 10px rgba(1, 140, 116, 0.5);
}
.secondary-text {
  color: #cfa22d !important;
}

.cyber-card {
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: 1px solid transparent !important;
}
.cyber-card:hover {
  transform: scale(1.02);
  border-color: #018c74 !important;
  box-shadow: 0 0 20px rgba(1, 140, 116, 0.2) !important;
}

.img-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, transparent 50%, rgba(0, 20, 18, 0.9));
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.cyber-desc {
  color: rgba(255, 255, 255, 0.7) !important;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.6;
}

.cyber-save-btn {
  color: #002d25 !important;
  font-weight: 900 !important;
  letter-spacing: 1px;
}
.cyber-search >>> .v-input__control {
  border-radius: 50px;
}

.glow-chip {
  box-shadow: 0 0 8px #018c74;
  font-weight: bold;
}
.glow-hover:hover {
  filter: drop-shadow(0 0 5px #018c74);
  transform: scale(1.2);
}
.glow-hover-red:hover {
  filter: drop-shadow(0 0 5px #ff5252);
  transform: scale(1.2);
}

.grayscale {
  filter: grayscale(1) opacity(0.4);
}
.opacity-1 {
  opacity: 0.1;
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
